package com.kinoshazam.analytics

import analytics.AnalyticsLogger
import io.github.aakira.napier.Napier

object NapierAnalyticsLogger : AnalyticsLogger {
    override fun d(message: String) {
        Napier.d(message, tag = TAG)
    }

    override fun e(message: String, error: Throwable?) {
        Napier.e(message, error, tag = TAG)
    }

    private const val TAG = "Analytics"
}
